// extracted by mini-css-extract-plugin
export var black = "_2b-6";
export var brand = "_2b-1";
export var ddefault = "_2b-0";
export var error = "_2b-3";
export var gray = "_2b-2";
export var highContrast = "_2b-8";
export var outline = "_2b-7";
export var success = "_2b-5";
export var warning = "_2b-4";